import { type FC, memo } from "react";
import classNames from "classnames";
import ProductPreferredIndicator from "~/features/productDetails/components/ProductPreferredIndicator";
import { type IconSize } from "~/common/components/icon/IconSize";
import { PopperTooltip } from "~/common/components/Tooltip";
import CopyToClipboard from "~/features/productDetails/components/CopyToClipboard";
import { useProductDetailsUrl } from "~/features/PackageRestriction/hooks/useProductDetailsUrl";
import type { ProductData } from "~/domains/product/types/ProductData";
import { Link, LinkType } from "~/common/components/Link";

interface DesignationProps {
  className?: string;
  designation: string;
  isPreferred?: boolean;
  reservePreferredSpace?: boolean;
  size: FontSize;
  iconSize?: IconSize;
  tooltipSide?: "left" | "right" | "bottom";
  title?: string;
  noCssColor?: boolean;
  as?: keyof JSX.IntrinsicElements;
  showCopyClipboard?: boolean;
  clickable?: boolean;
  product?: Pick<
    ProductData,
    "images" | "manufacturerLogoUrl" | "brandLogoUrl" | "url" | "isOptime" | "sapMaterialNumber" | "code"
  >;
}

// TODO: Add product url param, to avoid nested <a> issue
const ProductDesignation: FC<DesignationProps> = (props) => {
  const {
    className,
    designation,
    isPreferred,
    reservePreferredSpace,
    size: fontCls,
    tooltipSide,
    iconSize,
    title,
    noCssColor,
    showCopyClipboard,
    as = "span",
    product = null,
    clickable = false,
  } = props;
  const cls = classNames("scha__product-designation", className, !noCssColor && "scha__product-designation--set-color");

  const Cmp = as;

  let label = (
    <Cmp className={classNames(fontCls, "scha__product-designation__label")} data-test-id={"product-designation"}>
      {designation}
    </Cmp>
  );

  const productUrl = product && useProductDetailsUrl(product);

  if (clickable && productUrl) {
    label = (
      <Link variant={LinkType.SECONDARY} href={productUrl}>
        {label}
      </Link>
    );
  }

  if (title) {
    label = (
      <PopperTooltip tooltipContent={<span className={"f-no-wrap"}>{title}</span>} className={"d-inline"}>
        {label}
      </PopperTooltip>
    );
  }

  const renderPreferred = isPreferred || reservePreferredSpace;

  return (
    <div className={cls}>
      {renderPreferred && (
        <ProductPreferredIndicator
          className={classNames("icon-margin", !isPreferred && "v-hidden")}
          side={tooltipSide}
          iconSize={iconSize}
        />
      )}
      {label}
      {showCopyClipboard && <CopyToClipboard text={designation} iconSize={iconSize} />}
    </div>
  );
};

export default memo(ProductDesignation);
